import { accountApiWithAuth } from '@/api/account_api';
import { useQuery } from '@tanstack/react-query';

export const accountQueryKeys = {
  all: () => ['account'] as const,
  groups: () => [...accountQueryKeys.all(), 'groups'] as const,
};

export const useGetGroupsQuery = ({ isEnabled = true } = {}) => {
  return useQuery({
    queryKey: accountQueryKeys.groups(),
    queryFn: async () => accountApiWithAuth.getGroups(),
    enabled: isEnabled,
  });
};
